import { render, staticRenderFns } from "./PresentationSharingView.vue?vue&type=template&id=cb362204"
import script from "./PresentationSharingView.vue?vue&type=script&lang=js"
export * from "./PresentationSharingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports